/**
 * /match/request 기초생활수급자 키워드 유입 → 기초수급자 장례 혜택 랜딩
 * (구 실험 #327 B, 실험 종료 후 상시 채택).
 *
 * 노출 조건 (무빈소·비용 seg 패턴):
 *  - 광고 유입(n_query/n_ad/gclid) + 키워드에 "수급자" 포함(부분 매칭).
 *  - ?template=beneficiary 명시 쿼리(결정적, 새로고침에도 유지) — 마케팅 링크용.
 *
 * 무빈소·비용 다음 우선순위로 판정(키워드가 배타적이라 겹치지 않음).
 */

/** 이번 seg 대상 토큰. 키워드에 포함되면 기초수급자 관심 유입으로 본다. (기초생활수급자·기초수급자 모두 포함) */
const RECIPIENT_KEYWORD_TOKEN = "수급자";

const normalize = (s: string) => s.replace(/\s+/g, "");

/**
 * n_query/utm_term에 "수급자"가 포함되는지 판정(부분 매칭, 공백 무시).
 * @param keyword useAdKeywordTargeting()의 keyword (n_query || utm_term)
 */
export const isRecipientAdKeyword = (keyword?: string | null) =>
  !!keyword && normalize(keyword).includes(RECIPIENT_KEYWORD_TOKEN);
